import { SELLER_AVAILABILITY } from "@/gql/availability";
import { getApolloData } from "@/utils/apollo/get-data";
import { logger } from "@/utils/logger";

// You need to define the GQL query for seller availability

export type SellerAvailability = {
	currentSellerSlots: {
		startTime: string;
		endTime: string;
	}[];
	otherSellerSlots: {
		startTime: string;
		endTime: string;
	}[];
	buyerSlots: {
		startTime: string;
		endTime: string;
	}[];
};

export async function getSellerAvailability(params: {
	sellerId?: string;
	buyerUnitId?: string;
	unitId?: string;
	sellerUnitId?: string;
	projectId?: string;
}): Promise<SellerAvailability | { error: { message: string; code: string } }> {
	const { sellerId, buyerUnitId, unitId, sellerUnitId, projectId } = params;
	const { data, error } = await getApolloData({
		query: SELLER_AVAILABILITY,
		variables: {
			filters: {
				visitAvailabilitySlotsV2: {
					sellerId: sellerId ?? null,
					buyerUnitId: buyerUnitId ?? null,
					unitId,
					sellerUnitId,
					projectId,
				},
			},
		},
	});

	if (error) {
		logger.error("Failed to fetch seller availabilities", {
			method: "getSellerAvailability",
			query: "SELLER_AVAILABILITY (units.visitAvailabilitySlotsV2)",
			params,
			error,
		});
		return { error: { message: "Failed to fetch seller availability", code: "FAILED_TO_FETCH_SELLER_AVAILABILITY" } };
	}

	if (!data) {
		return { error: { message: "No seller availability found", code: "NO_SELLER_AVAILABILITY" } };
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const seAvailability = (data as any)?.units?.visitAvailabilitySlotsV2;

	if (!seAvailability) {
		return { error: { message: "No seller availability data found", code: "NO_SELLER_AVAILABILITY_DATA" } };
	}

	return seAvailability as unknown as SellerAvailability;
}
